import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { PainSection } from './components/sections/PainSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { VolumeBenefitsSection } from './components/sections/VolumeBenefitsSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { ProductShowcaseSection } from './components/sections/ProductShowcaseSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { OfferSection } from './components/sections/OfferSection';
import { CostSection } from './components/sections/CostSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { CountdownSection } from './components/sections/CountdownSection';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="2zmwhmy3ufmc9">
      <noscript data-id="element-1" data-mp="33nq9g2keplaf">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="33n6wz1dizp3s" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="3dlw5w4ng1z7w" />
      <main data-id="element-4" data-mp="3dmfo7mh0apmg">
        <StatsSection data-id="element-5" data-mp="3dirv2ofh4589" />
        <ProblemSection data-id="element-6" data-mp="nvj35ett6cp7" />
        <PainSection data-id="element-7" data-mp="nwc39wy9i3yd" />
        <SolutionSection data-id="element-8" data-mp="nur8c681cizz" />
        <VolumesSection data-id="element-9" data-mp="nxn4bp0boxls" />
        <VolumeBenefitsSection data-id="element-10" data-mp="sudl6ejybx89" />
        <BonusesSection data-id="element-11" data-mp="stkns46vuk2s" />
        <ProductShowcaseSection data-id="element-12" data-mp="sssqmoxn0eae" />
        <TestimonialsSection data-id="element-13" data-mp="36hvn4muyo06" />
        <AudienceSection data-id="element-14" data-mp="35ovwnmbgyrj" />
        <ComparisonSection data-id="element-15" data-mp="34x29ica5b3w" />
        <CountdownSection data-id="element-16" data-mp="38b6kw4i7udz" />
        <OfferSection data-id="element-17" data-mp="3udax89lkcp58" />
        <CostSection data-id="element-18" data-mp="3ubzso7kandd2" />
        <FaqSection data-id="element-19" data-mp="3ucjdbw1bwfus" />
        <FinalCtaSection data-id="element-20" data-mp="3uf5m1yzyh1el" />
      </main>
      <PurchasePopup data-id="element-21" data-mp="d4xlz5e29t8m" />
    </div>;
}